import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';

import Dialog from '../../services/Dialogs'


const ModalBoutiquesPendienteEstatusCambio = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, pendiente } = params


  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
    folio : yup.string().required(mensajes_validacion_generico),
  });


  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const enviarFormulario = async (registro:any,event:any,estado:string) =>{
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.update( `boutique/pendiente/cambio_estado/${estado}/${pendiente.uuid}` , { ...registro })

          if(res_){
            toast.success('MENSAJE')
            setTimeout(()=>{
              handleClose()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
            // console.log(e.response.data)
          } 
          
        }
       
  }


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Cambiar Estatus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {

          }
          <small>Folio</small>
          <h5>{pendiente.folio}</h5>

    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e,'ATENDIDO')}}
      initialValues={{
            folio : "",
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>


            <Form.Group className="mb-3" controlId="folio">
              <Form.Label>Folio de Servicio</Form.Label>
              <Form.Control
                required
                name="folio"
                value={values.folio}
                onBlur={(e)=>{ setFieldValue('folio', e.target.value.toUpperCase() ) }}
                onChange={(e)=>{ setFieldValue('folio', e.target.value ) }}
                isInvalid={!!errors.folio}
                style={{textTransform:'uppercase'}}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.folio}</>} </Form.Control.Feedback>
            </Form.Group>





        </Form>
      )}
    </Formik>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={(e:any)=>{enviarFormulario({}, e,'CANCELADO')}}>
            Cancelar Pendiente
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
          <Button variant="success" form='my-form' type="submit">Marcar de Atendido</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalBoutiquesPendienteEstatusCambio;